import React from "react";
import type { WrapPageElementBrowserArgs } from "gatsby";
import cx from "classnames";
import * as styles from "./PageRoot.css";
import { lightColorScheme } from "./core/styleguide.css";
import { EndOfLifeWarning } from "./EndOfLifeWarning";

export const PageRoot: React.FC<WrapPageElementBrowserArgs> = ({ element }) => {
  return (
    <div className={cx(styles.page, lightColorScheme)}>
      <EndOfLifeWarning />
      {element}
    </div>
  );
};
